import { useSession } from '@faststore/sdk'
import { useRef } from 'react'
import { LoginRegister } from './LoginRegister'
import { PrivateAreaLinks } from './PrivateAreaLinks'

import { RenderClient } from 'src/components/RenderClient'
import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { useOnClickAway } from 'src/sdk/ui/useOnClickAway'
import storeConfig from '../../../../../store.config'
import { UserIconWrapper } from './UserIconWrapper'

export const UserInfo = () => {
  const { hasClickedOnPrivateArea, setHasClickedOnPrivateArea } =
    useGlobalNavigation()
  const { person } = useSession()

  const ref = useRef<HTMLDivElement>(null)

  const handleClickAwayCallback = () => {
    setHasClickedOnPrivateArea(false)
  }

  useOnClickAway({
    isOpened: hasClickedOnPrivateArea,
    ref,
    callback: handleClickAwayCallback,
  })

  const handleClick = () => {
    setHasClickedOnPrivateArea(!hasClickedOnPrivateArea)
  }

  return (
    <RenderClient>
      {person == null && (
        <>
          <div
            className="hidden xs:block relative dropdown-subheader-component account-dropdown-nologged"
            ref={ref}
          >
            <button
              className={`flex flex-row items-center gap-3 text-xs font-normal tracking-[0.048px] !leading-[130%] bg-yellow cursor-pointer focus:outline-none dropdown-subheader-link p-0 ${
                hasClickedOnPrivateArea ? 'open' : ''
              }`}
              onClick={handleClick}
            >
              <span className="sr-only 2xl:hidden">
                Area personale - Accedi o registrati
              </span>
              <UserIconWrapper />
              <span className="hidden 2xl:block text-left">
                <span className="block text-xs !leading-[130%] tracking-[0.048px] font-normal">
                  Area personale
                </span>
                <span className="block text-sm !leading-[130%] tracking-[0.035px] font-semibold">
                  Accedi o registrati
                </span>
              </span>
            </button>
            <LoginRegister />
          </div>

          <a
            href={`${storeConfig.loginUrl}?returnUrl=/account`}
            className="block xs:hidden"
            aria-label="Accedi"
          >
            <UserIconWrapper />
          </a>
        </>
      )}

      {person?.id && (
        <>
          <div
            className="hidden xs:block relative dropdown-subheader-component account-dropdown-logged"
            ref={ref}
          >
            <button
              className={`flex flex-row items-center gap-3 text-xs font-normal tracking-[0.048px] !leading-[130%] bg-yellow focus:outline-none cursor-pointer dropdown-subheader-link p-0 ${
                hasClickedOnPrivateArea ? 'open' : ''
              }`}
              onClick={handleClick}
            >
              <span className="sr-only 2xl:hidden">
                Area personale - Bentornato
              </span>
              <UserIconWrapper className="hidden 2xl:flex" />
              <span className="flex items-center justify-center h-8 w-8 2xl:hidden text-xs !leading-[130%] tracking-[0.035px] font-semibold border border-solid border-yellow-200 rounded-full">
                <span className="block">{`${person?.familyName
                  ?.charAt(0)
                  ?.toUpperCase()}${person?.givenName
                  .charAt(0)
                  ?.toUpperCase()}`}</span>
              </span>
              <span className="hidden 2xl:block text-left">
                <span className="block text-xs !leading-[130%] tracking-[0.048px] font-normal">
                  Ciao, bentornato
                </span>
                <span className="block text-sm !leading-[130%] tracking-[0.035px] font-semibold">
                  {person.givenName}
                </span>
              </span>
            </button>

            <PrivateAreaLinks
              givenName={person?.givenName}
              email={person?.email}
            />
          </div>

          <a
            href={`${storeConfig.loginUrl}?returnUrl=/account`}
            className="block xs:hidden"
          >
            <span className="flex items-center justify-center h-8 w-8 2xl:hidden text-xs !leading-[130%] tracking-[0.035px] font-semibold border border-solid border-yellow-200 rounded-full">
              <span className="block">{`${person?.familyName
                ?.charAt(0)
                ?.toUpperCase()}${person?.givenName
                ?.charAt(0)
                ?.toUpperCase()}`}</span>
            </span>
          </a>
        </>
      )}
    </RenderClient>
  )
}
